import { render } from "./RegisterPage.vue?vue&type=template&id=03343e90"
import script from "@/assets/js/register.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/register.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/register.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__